// Ported verbatim from legacy/index.html line 2761.
//
// Legacy:
//   function splitSentences(text) {
//     const parts = text.trim().split(/(?<=[.!?])\s+/);
//     return parts.filter(p => p.trim().length > 0);
//   }
//
// The heuristic is intentionally simple — it splits on sentence-ending
// punctuation followed by whitespace. Abbreviations like "z.B." or "Dr." are
// NOT handled as edge cases in the legacy implementation (they would split
// wrong, but legacy accepted that tradeoff). Decimals like "3.14" likewise
// split (no following whitespace, so fine). We keep 1:1 parity so Auto-Split
// matches vanilla behavior exactly for Latin text.
//
// Bewusste Erweiterung (2026-09-23, Spec 2026-09-23-script-support-design):
//   - ؟ (Arabisch) und । ॥ (Bengali Danda) zählen wie . ! ?
//   - nach 。！？ (CJK-Vollbreite) ist KEIN Whitespace nötig — Chinesisch setzt
//     zwischen Sätze keine Leerzeichen. Ein direkt folgendes schließendes
//     Anführungszeichen/Klammer (」』）】”’) bleibt am Satz.
//   Thai hat keine Satzzeichen; dort blendet die UI den Split aus
//   (detectScript === 'thai'), statt hier zu raten.
//
// Nachtrag 2026-09-24 (Audit): eine Folge von Satzzeichen ist EINE Einheit —
// `真的吗？！` ergab vorher einen Block nur aus „！". Für Lateinisch galt das
// implizit schon (Split erst am Whitespace), für CJK prüft der Lookahead jetzt
// auch auf weitere Satzzeichen.
//
// Edge cases:
//   - empty text → []
//   - single sentence / no boundary → [trimmed text]

const CJK_TERMINAL = '。！？';
const CJK_CLOSERS = '」』）】”’';

export function splitSentences(text: string): string[] {
  const trimmed = text.trim();
  if (!trimmed) return [];
  const parts = trimmed.split(
    new RegExp(
      `(?<=[.!?؟।॥])\\s+|(?<=[${CJK_TERMINAL}]+[${CJK_CLOSERS}]?)(?![${CJK_CLOSERS}${CJK_TERMINAL}])\\s*`,
    ),
  );
  return parts.map((p) => p.trim()).filter((p) => p.length > 0);
}

// Endet der Satz mit CJK-Satzzeichen (ggf. + schließendem Zeichen)?
const ENDS_CJK = new RegExp(`[${CJK_TERMINAL}][${CJK_CLOSERS}]*$`);
// Beginnt der nächste Satz mit einem CJK-Zeichen (Hanzi, Kana, vollbreite
// Zeichen, öffnende Anführung/Klammer)?
const STARTS_CJK = /^[\u3000-〿぀-ヿ㐀-䶿一-鿿豈-﫿＀-￯「『（【“‘]/;

/** Gegenstück zu splitSentences für den Block-Split. Zwischen zwei
 *  chinesischen Sätzen steht kein Leerzeichen; überall sonst (auch zwischen
 *  lateinischem Satzende und CJK-Anfang) eins — so bleibt
 *  `splitSentences(joinSentences(x))` für gemischte Texte stabil. */
export function joinSentences(sentences: string[]): string {
  let out = '';
  sentences.forEach((s, i) => {
    if (i === 0) {
      out = s;
      return;
    }
    const prev = sentences[i - 1];
    const sep = ENDS_CJK.test(prev) && STARTS_CJK.test(s) ? '' : ' ';
    out += sep + s;
  });
  return out;
}
